// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"df186dfff4657136c37d","293":"6606d5f9e9b95969d61b"}[chunkId] + ".js";
};